import React from 'react'
import { Link } from 'react-router-dom'

const AdminK8Tier2View = () => {
  return (
    <div>
      <div>AdminK8Tier2View</div>
      <Link to="/admin/program/k8/interventions">
        Go to Interventions with defaults
      </Link>
    </div>
  )
}

export default AdminK8Tier2View
